<template>
  <div class="view settings">
    <div class="content">
      <div class="header">
        <div v-if="user && user.firstName && !user.client.imageUrl" class="picture">
          {{ $utils.choosePictureName(user.client.name) }}
        </div>
        <img v-else class="picture" :src="user.client.imageUrl" />
        <div class="client-name">{{ user.client.name }}</div>
      </div>

      <div class="sub-header no-scroll-bar">
        <RouterLink class="link" :class="{ active: page.includes('account') }" to="/settings/account">{{ $t('accountSettings') }}</RouterLink>
        <RouterLink class="link" :class="{ active: page.includes('users') }" to="/settings/users">{{ $t('usersManagement') }}</RouterLink>
        <RouterLink class="link" :class="{ active: page.includes('billing') }" to="/settings/billing">{{ $t('billing') }}</RouterLink>
      </div>

      <RouterView :key="'settings' + $route.fullPath" :info="{ users }"></RouterView>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  async beforeRouteUpdate(to, from, next) {
    if (to.fullPath.includes('user') && !to.fullPath.includes('add')) {
      const result = await this.$store.dispatch('getUsers', { id: this.user.client.id });
      this.users = result.users;
    }
    next();
  },

  props: {
    page: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      users: [],
    };
  },

  computed: {
    ...mapGetters(['isLogged', 'user']),
  },

  async mounted() {
    if (!this.users || !this.users.length) {
      const result = await this.$store.dispatch('getUsers', { id: this.user.client.id });
      this.users = result.users;
    }
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.view {
  padding: 144px 0 64px;
  box-sizing: border-box;

  .content {
    .header {
      display: flex;
      align-items: center;

      .picture {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 70px;
        height: 70px;
        border-radius: 50%;
        color: colors.$black-color;
        background: colors.$white-color;
        margin: 0 32px 0 0;
        font-weight: 800;
        font-size: 28px;
      }

      .client-name {
        color: colors.$darkblue-color;
        font-weight: 500;
        font-size: 25px;
      }
    }
  }
}

@media only screen and (max-width: responsive.$layout-breakpoint-small) {
  .content {
    width: 100%;
    overflow: hidden;

    .sub-header {
      display: flex;
      align-items: center;
      padding: 0;
      overflow-x: auto;

      .link {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
        min-width: 250px;
        margin: 0;
      }
    }
  }
}
</style>
